import { EventEmitter, Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Comment } from '../models/comment';
import { Filter } from '../models/filter';
import { FormGroupDirective } from '@angular/forms';
import { Record } from '../models/record';
import { SearchModel } from '../models/search-model';
import { OtkList } from '../models/user-item-list';

@Injectable({
  providedIn: 'root',
})
export class BroadcastService {
  private searchModel = new Subject<SearchModel>();
  private login = new Subject<boolean>();
  private comment = new Subject<Comment>();
  private sidebar = new Subject<boolean>();
  private commentBox = new Subject<FormGroupDirective>();
  private sliderItem = new Subject<Record>();
  private filters = new Subject<Filter[]>();
  private allNotificationsRead = new Subject<boolean>();
  private profilePicture = new Subject<boolean>();
  private userData = new Subject<boolean>();
  private userLocation = new BehaviorSubject<boolean>(false);
  private listUnfollowed = new Subject<OtkList>();
  private authorUnfollowed = new Subject<string>();
  private disabledSmartBanner = new Subject<boolean>();
  private reloadGroups = new Subject<void>();
  private editGroup = new Subject<{ groupId: string; isSaveGroup: boolean }>();
  private changeGroup = new Subject<EventEmitter<void>>();
  private sliderUserActions = new Subject<void>();

  searchModel$ = this.searchModel.asObservable();
  login$ = this.login.asObservable();
  comment$ = this.comment.asObservable();
  sidebar$ = this.sidebar.asObservable();
  commentBox$ = this.commentBox.asObservable();
  sliderItem$ = this.sliderItem.asObservable();
  filters$ = this.filters.asObservable();
  allNotificationsRead$ = this.allNotificationsRead.asObservable();
  profilePicture$ = this.profilePicture.asObservable();
  userData$ = this.userData.asObservable();
  userLocation$ = this.userLocation.asObservable();
  listUnfollowed$ = this.listUnfollowed.asObservable();
  authorUnfollowed$ = this.authorUnfollowed.asObservable();
  disabledSmartBanner$ = this.disabledSmartBanner.asObservable();
  reloadGroups$ = this.reloadGroups.asObservable();
  editGroup$ = this.editGroup.asObservable();
  changeGroup$ = this.changeGroup.asObservable();
  sliderUserActions$ = this.sliderUserActions.asObservable();

  constructor() {}

  broadcastSearchModel(searchModel: SearchModel) {
    this.searchModel.next(searchModel);
  }

  broadcastLogin(login: boolean) {
    this.login.next(login);
  }

  broadcastComment(comment: Comment) {
    this.comment.next(comment);
  }

  broadcastCommentBox(commentBox: FormGroupDirective) {
    this.commentBox.next(commentBox);
  }

  broadcastSidebar(open: boolean) {
    this.sidebar.next(open);
  }

  broadcastFilters(filters: Filter[]) {
    this.filters.next(filters);
  }

  broadcastSliderItem(record: Record) {
    this.sliderItem.next(record);
  }

  broadcastAllNotificationsRead(value: boolean) {
    this.allNotificationsRead.next(value);
  }

  broadcastProfilePicture(value: boolean) {
    this.profilePicture.next(value);
  }

  broadcastUserData(value: boolean) {
    this.userData.next(value);
  }

  broadcastUserLocation(value: boolean) {
    this.userLocation.next(value);
  }

  broadcastListUnfollowed(value: OtkList) {
    this.listUnfollowed.next(value);
  }

  broadcastAuthorUnfollowed(value: string) {
    this.authorUnfollowed.next(value);
  }

  broadcastDisabledSmartBanner(value: boolean) {
    this.disabledSmartBanner.next(value);
  }

  broadcastReloadGroups() {
    this.reloadGroups.next();
  }
  broadcastEditGroup(groupId: string, isSaveGroup?: boolean) {
    this.editGroup.next({ groupId: groupId, isSaveGroup: isSaveGroup });
  }
  broadcastChangeGroup(event: EventEmitter<void>) {
    this.changeGroup.next(event);
  }
  broadcastSliderUserActions() {
    this.sliderUserActions.next();
  }
}
